export interface IMCSOptions {
  matchWithStartsWithByDefault: boolean;
  matchCaseInsensitiveByDefault: boolean;

  wordSplitter: string;
  matchAllWords: boolean;
  matchInEveryColumn: boolean;

  orderByFirstSearchColumnWhenNoOrderByColumns: boolean;

  maximizeResultTo: number;
}
